import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const OnboardingWelcomePage = lazy(() => import('~/features/onboarding/pages/onboarding-page'));

/** Paid Ads onboarding flow — the former /onboarding index, now at /onboarding/paid-ads. */
export const Route = createFileRoute('/_authenticated/_tenant/onboarding/paid-ads')({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <OnboardingWelcomePage />
    </Suspense>
  ),
});
